import React from 'react'
import {Route, Router, Switch} from 'react-router-dom'
import {createBrowserHistory, History, LocationState} from 'history'
import {NavigatorForMemberPageImpl} from './Members/Navigator/NavigatorForMemberPageImpl'
import {NavigatorForAdminPageImpl} from './Admins/Navigator/NavigatorForAdminPageImpl'
import NetworkAnnouncementsRepo from './Admins/Models/Announcement/Repo/NetworkAnnouncementsRepo'
import BrowserFetchWrapper from './Network/BrowserFetchWrapper'
import NetworkMemberRepo from './Members/Repo/NetworkMemberRepo'
import NetworkAdministratorRepo from './Admins/Models/Administrator/Repo/NetworkAdministratorRepo'
import NetworkMemberAgreementRepo from './Members/Repo/NetworkMemberAgreementRepo'
import {SearchPostCodeImpl} from './Common/SearchPostCodeImpl'
import {MembersAuthProvider} from './Members/Auth/MembersAuthProvider'
import {NetworkADMembersRepo} from './Admins/Models/Member/Repo/NetworkADMembersRepo'
import loadable from '@loadable/component'
import {NetworkExportDataRepo} from './Admins/Models/ExportData/Repo/NetworkExportDataRepo'
import {AdminsAuthProvider} from './Admins/Auth/AdminsAuthProvider'
import NetworkMovieContentsRepo from './Admins/Models/MovieContent/Repo/NetworkMovieContentsRepo'
import {NetworkPhotoContentsRepo} from './Admins/Models/PhotoContent/Repo/NetworkPhotoContentsRepo'
import {NetworkMemberSignboardRepo} from './Members/Repo/NetworkMemberSignboardRepo'
import {NetworkSideNavigationRepo} from './Admins/Models/SideNavigation/Repo/NetworkSideNavigationRepo'
import {NetworkAdminAgreementsRepo} from './Admins/Models/Agreement/Repo/NetworkAdminAgreementsRepo'

const isAppAdmin = (): boolean =>
  !!process.env.REACT_APP_ADMIN_CLIENT_ROOT?.startsWith(location.origin)

const App: React.VFC = () => {
  const serverUserWithPassword = process.env.REACT_APP_MEMBUCKET_ADMIN_APP_USER_WITH_PASSWORD
  const headers: HeadersInit | undefined =
    serverUserWithPassword ? {'Authorization': 'Basic ' + btoa(serverUserWithPassword)} : undefined
  const browserHistory: History<LocationState> = createBrowserHistory()
  const navigatorForMember = new NavigatorForMemberPageImpl(browserHistory)
  const navigatorForAdmin = new NavigatorForAdminPageImpl(browserHistory)
  const browserFetchWrapper = new BrowserFetchWrapper(headers)
  const administratorRepo = new NetworkAdministratorRepo(browserFetchWrapper)
  const announcementsRepo = new NetworkAnnouncementsRepo(browserFetchWrapper)
  const movieContentsRepo = new NetworkMovieContentsRepo(browserFetchWrapper)
  const photoContentsRepo = new NetworkPhotoContentsRepo(browserFetchWrapper)
  const adMembersRepo = new NetworkADMembersRepo(browserFetchWrapper)
  const extractDataRepo = new NetworkExportDataRepo(browserFetchWrapper)
  const adminAgreementsRepo = new NetworkAdminAgreementsRepo(browserFetchWrapper)
  const sideNavigationRepo = new NetworkSideNavigationRepo()
  const memberRepo = new NetworkMemberRepo(browserFetchWrapper)
  const memberSignboardRepo = new NetworkMemberSignboardRepo(browserFetchWrapper)
  const memberAgreementRepo = new NetworkMemberAgreementRepo(browserFetchWrapper)
  const searchPostCode = new SearchPostCodeImpl()

  const AppMembers = loadable(() => import('./AppMembers' /* webpackChunkName: "AppMembers" */))
  const AppAdmin = loadable(() => import('./Admins/AppAdmin' /* webpackChunkName: "AppAdmin" */))

  return (
    <Router history={browserHistory}>
      <Switch>
        <Route>
          {isAppAdmin() ?
            <AdminsAuthProvider>
              <AppAdmin
                navigator={navigatorForAdmin}
                administratorRepo={administratorRepo}
                announcementsRepo={announcementsRepo}
                movieContentsRepo={movieContentsRepo}
                photoContentsRepo={photoContentsRepo}
                adMembersRepo={adMembersRepo}
                exportDataRepo={extractDataRepo}
                agreementsRepo={adminAgreementsRepo}
                sideNavigationRepo={sideNavigationRepo}
              />
            </AdminsAuthProvider>
            :
            <MembersAuthProvider memberAgreementRepo={memberAgreementRepo}>
              <AppMembers
                navigator={navigatorForMember}
                memberRepo={memberRepo}
                memberSignboardRepo={memberSignboardRepo}
                memberAgreementRepo={memberAgreementRepo}
                searchPostCode={searchPostCode}
              />
            </MembersAuthProvider>
          }
        </Route>
      </Switch>
    </Router>
  )
}

export default App
